import React from 'react';

import Button from 'common/inputs/Button';
import Link from 'common/Link';

import 'css/components/www/_LandingCTAButtons.scss';

type Props = {
  renderDemoButton?: boolean;
};
const LandingCTAButtons = ({ renderDemoButton }: Props) => {
  return (
    <div className="landingCTAButtons">
      <Link className="cta" to="/register">
        <Button buttonType="greenButton" value="Get Started" />
      </Link>
      {renderDemoButton && (
        <Link className="cta" to="/request-demo">
          <Button buttonType="ghostButton" value="Request a Demo" />
        </Link>
      )}
    </div>
  );
};

export default LandingCTAButtons;
